import React from 'react';
import Text from '@bufferapp/ui/Text';
import { useSplitEnabled } from '@bufferapp/features';
import { useAppSelector } from '~/store';
import { selectCurrentOrganizationId } from '~/organizations/selectors';
import { BufferTracker } from '@bufferapp/buffer-tracking-browser-ts';
import useDismissBanner, {
  BannerTypes,
} from '~/profile-page/hooks/useDismissBanner';
import Tag from '@bufferapp/ui/Tag';
import { useDismissedBanners } from '~/accountContext';
import { Layout, Container } from './styles';

export const InstagramStoriesPromoBanner = () => {
  const organizationId = useAppSelector((state) =>
    selectCurrentOrganizationId(state)
  );

  const { isEnabled: igStoriesEnabled } = useSplitEnabled('ig-stories');

  const dismissedBanners = useDismissedBanners();
  const showBanner =
    igStoriesEnabled &&
    dismissedBanners &&
    !dismissedBanners.includes('instagramStoriesPromo');

  const { onDismissBanner } = useDismissBanner({
    banner: BannerTypes.instagramStoriesPromo,
  });

  const onDismissClicked = () => {
    BufferTracker.mastodonChannelPromoDismissed({
      organizationId,
      clientName: 'publishWeb',
      product: 'publish',
    });
    onDismissBanner();
  };

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!showBanner) return <></>;

  return (
    <Layout
      dismiss={() => {
        onDismissClicked();
      }}
      type="note"
      disableAnimation
    >
      <Container>
        <Tag color="green">New</Tag>
        <Text type="h3">Schedule Instagram Stories without Reminders</Text>
        <Text type="p">
          You can now create and schedule Stories to Instagram directly, as
          you’d do for any other post, from the queue or calendar.
        </Text>
        <Text type="p">
          Don&apos;t worry, you can still create Stories and set them as
          Reminders in this tab.
        </Text>
      </Container>
      <img
        src="https://buffer-publish.s3.amazonaws.com/images/stories_tab-banner.svg"
        alt="Instagram Stories Promo Banner"
        width={384}
      />
    </Layout>
  );
};
